const getClientsInfoSelector = (state) => state.clientInfoReducer;

export const selectedClientIdSelector = (state) =>
  getClientsInfoSelector(state).selectedClient;
